import { createReducer } from '@reduxjs/toolkit';

import {
    storeAdminUsersFiltersData,
    clearFiltersState,
    storeAdminTiersFiltersData,
    storeCandidatesSelectionFilters,
    storeSavedJobsFilters,
} from './actions';

const initialState: any = {
    data: null,
    usersFilters: {
        page: '',
        ordering: '',
        search: ''
    },
    tiersFilters: {
        page: ''
    },
    candidatesFilters: {
        page: '',
    },
    jobsFilters: {
        page: '',
        search: ''
    }
};

export const filtersReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(storeAdminUsersFiltersData.fulfilled, (state, { payload }) => {
            const { page, ordering, search } = payload;
            state.usersFilters = { page, ordering, search };
        })
        .addCase(storeAdminTiersFiltersData.fulfilled, (state, { payload }) => {
            const { page } = payload;
            state.tiersFilters = { page };
        })
        .addCase(storeCandidatesSelectionFilters.fulfilled, (state, { payload }) => {
            const { page } = payload;
            state.tiersFilters = { page };
        })
        .addCase(storeSavedJobsFilters.fulfilled, (state, { payload }) => {
            const { page, search } = payload;
            state.jobsFilters = { page, search };
        })
        .addCase(clearFiltersState.fulfilled, (state, { payload }) => {
            state.usersFilters = { page: '', ordering: '', search: '' };
            state.tiersFilters = { page: '' };
            state.data = payload;
        });
});

export default filtersReducer;
